<template>
  <div class="section container">
    <div class="box">
      <h1 class="title">You're Awesome! Thank you for your submission!</h1>
      <router-link to="/">
        <button class="button is-link">Back to home</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  metaInfo: {
    title: "Success",
    titleTemplate: "%s - Meet John",
    meta: [
      {
        name: "Success",
        content: "Successful Form Submission"
      }
    ]
  }
};
</script>
